__turbopack_context__.v({
  "alert": "yZDD7q_alert",
  "modalFooter": "yZDD7q_modalFooter",
});
